import React, { useMemo } from 'react';
import CardCommon from '@op/components/CardCommon';
import useIntls from '@opm/hooks/useIntls';
import HashtagAISummary from '../HashtagAISummary';
import VideoContent from '../VideoContent';
import './index.scss';
import { IHashtagItem } from '../../HashtagTable';

interface IHashtagRightContentProps {
  hashtagInfo: IHashtagItem | null;
  filter?: {
    start_time?: string;
    end_time?: string;
    time_range?: string;
    [key: string]: any;
  };
  onClose: () => void;
}

export default function HashtagRightContent({
  hashtagInfo,
  filter,
  onClose,
}: IHashtagRightContentProps) {
  const { intl } = useIntls();

  const summaryFilter = useMemo(
    () => ({
      ...(filter || {}),
      hashtag: hashtagInfo?.hashtag,
      time_range: hashtagInfo?.time_range || filter?.time_range,
    }),
    [filter, hashtagInfo?.hashtag, hashtagInfo?.time_range],
  );

  return (
    <CardCommon
      className="dbom-hashtag-video-player"
      title={hashtagInfo?.hashtag}
      hasDownload
      downloadIcon="clonse"
      downLoadTips={intl('Close')}
      handleDownloadOnClick={onClose}
    >
      <HashtagAISummary filter={summaryFilter} />
      <VideoContent
        videoList={hashtagInfo?.top_video_list}
        hashtag={hashtagInfo?.hashtag}
      />
    </CardCommon>
  );
}
